// Backend calls for Dream Companies.

import { auth } from "../firebase";

const API_BASE = process.env.REACT_APP_API_URL ?? "http://localhost:5050";

/**
 * Ask the backend to find the company's job board (Greenhouse, Lever, Workday, ...),
 * save it as boardKey and fill in its open roles. Resolves to whether it
 * worked; failures are logged, and the page retries companies still waiting.
 */
export async function detectBoard(companyId: string): Promise<boolean> {
  const user = auth.currentUser;
  if (!user) return false;
  try {
    const response = await fetch(`${API_BASE}/dream-companies/${companyId}/board`, {
      method: "POST",
      headers: { Authorization: `Bearer ${await user.getIdToken()}` },
    });
    if (!response.ok) console.error("Job board check failed:", response.status);
    return response.ok;
  } catch (e) {
    console.error("Job board check failed:", e);
    return false;
  }
}

/**
 * Ask the backend to match every dream company's open roles again, after the
 * user changes their roles, job types or locations. Failures are only logged:
 * the checker rematches each company once a day anyway.
 */
export async function rematchDreamCompanies(): Promise<void> {
  const user = auth.currentUser;
  if (!user) return;
  try {
    const response = await fetch(`${API_BASE}/dream-companies/rematch`, {
      method: "POST",
      headers: { Authorization: `Bearer ${await user.getIdToken()}` },
    });
    if (!response.ok) console.error("Dream companies rematch failed:", response.status);
  } catch (e) {
    console.error("Dream companies rematch failed:", e);
  }
}
